module.exports = __webpack_public_path__ + "fonts/Nunito-BoldItalic.534bd4b.ttf";